import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import CustomSnackbar from "components/Snackbar/SnackbarContent";
import { useIntl } from "react-intl";

let displayed = [];

const Notifier = () => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const notifications = useSelector(
    (store) => store.common.notifications || []
  );
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = (id) => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = (id) => {
    displayed = [...displayed.filter((key) => id !== key)];
  };

  React.useEffect(() => {
    notifications.forEach(
      ({
        key,
        message,
        options = {},
        dismissed = false,
        hash,
        action = null,
        ...props
      }) => {
        if (dismissed) {
          // dismiss snackbar using notistack
          closeSnackbar(key);
          return;
        }

        // do nothing if snackbar is already displayed
        if (displayed.includes(key)) return;

        // display snackbar using notistack
        enqueueSnackbar(message, {
          key,
          autoHideDuration: props.autoHideDuration,
          // =====================================
          // 1) 使用 content 屬性來取代預設樣式
          content: (snackbarKey, snackMessage) => (
            <CustomSnackbar
              id={snackbarKey}
              variant={options.variant || "default"}
              message={snackMessage}
              // 2) 讓按鈕可以關閉這個 Snackbar
              onClose={() => {
                // 這裡才是呼叫 closeSnackbar
                closeSnackbar(snackbarKey);
              }}
              // 如果你要原本 options 也可以攜帶進來
              {...options}
              // 如果要保留 hash 相關動作，可以自行將按鈕包在 CustomSnackbar
              action={
                hash ? (
                  <a
                    style={{
                      fontWeight: "bold",
                      backgroundColor: "#97eac9",
                      borderRadius: 10,
                      padding: "12px 12px",
                      color: "black",
                    }}
                    onClick={() =>
                      window.open(`https://etherscan.io/tx/${hash}`, "_blank")
                    }
                  >
                    {formatMessage({ id: "global.btn.view" })}
                  </a>
                ) : (
                  action
                )
              }
              {...props}
            />
          ),
          onExited: (event, myKey) => {
            removeDisplayed(myKey);
          },
        });

        // keep track of snackbars that we've displayed
        storeDisplayed(key);
      }
    );
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
};

// const StyledLink = styled.a`
//   font-weight: bold;
//   background-color: #97eac9;
//   border-radius: 10px;
//   padding: 6px 12px;
//   color: black;
// `
export default Notifier;
